import React from 'react';

const BlueTransition = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 283">
    <path fill="#6499C6"
      d="M979 122.5C647.081 199.752 190.952 0 0 0h1440v273.167c0-123.162-275.66-193.803-461-150.667z" />
  </svg>
);

export default BlueTransition;